import React from 'react';
import Rupee from 'views/Rupee';
import {
  rupees,
} from 'config/utils';

import {
  EVENT,
  SERVICE,
} from 'config/ProductTypes';

export const getOfferPriceLabel = ({ priceBoost, minPrice, maxPrice, discount }) => {
  const minP = Number(minPrice),
      maxP = Number(maxPrice),
      discountedP = minP - Number(discount);

  if ( priceBoost ) {
    if ( minP === 0 ) {
      return <span style={{ fontSize: '0.75rem' }}>Pay What You Want</span>;
    } else {
      return <span>Min <Rupee value={rupees(minP)} /></span>;
    }
  } else {
    if (discount > 0) {
      return  (
        <div>
          <span className="text-grey" style={{ textDecoration: 'line-through' }}>
            <Rupee value={minPrice} />
          </span>
          <span className="push--left text-green">
            <Rupee value={discountedP} />
          </span>
        </div>
      );
    } else if ( minP !== maxP ) {
      return <span>Min <Rupee value={rupees(minP)} /></span>;
    } else if (minP === 0) {
      return <span style={{ fontSize: '0.9rem' }}>Free</span>;
    } else {
      return <Rupee value={rupees(minP)}/>;
    }
  }
};

export const getPurchaseButtonLabel = ({ priceBoost, minPrice, offerType, isCartable }) => {
  if (isCartable) {
    return 'Add to Cart';
  }

  if (!priceBoost && Number(minPrice) === 0) {
    return 'Get It';
  } else if (offerType) {
    return offerType == EVENT ? 'Buy Tickets' : offerType == SERVICE ? 'Pay Now' : 'Buy Now';
  }
  return 'Buy';
};



// WEBPACK FOOTER //
// ./src/common/utils/labelUtils.js